import React from 'react'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import styles from './style.module.css'
const index = () => {
  return (
      <div className={styles.Nav}>
      <span className={styles.icon1}><NotificationsNoneIcon sx={{fontSize:30}} /></span>
      <span className={styles.icon2}><AccountCircleIcon sx={{fontSize:30}} /></span>
        <div className={styles.adminDetail}>
            <p className={styles.name}>Admin</p>
            <p className={styles.email}>Email@gmail.com</p>
        </div>
        </div>
  )
}

export default index
